import { render, staticRenderFns } from "./SelectorSimple.vue?vue&type=template&id=5995e229&"
import script from "./SelectorSimple.vue?vue&type=script&lang=js&"
export * from "./SelectorSimple.vue?vue&type=script&lang=js&"
import style0 from "./SelectorSimple.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports